
/* eslint 'no-dupe-keys' : 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Modal } from "reactstrap";
import Grid from "@material-ui/core/Grid";

import SubTitle from "components/FacilityRequestComponents/ResourceComponents/SubTitle";
import AfterHoursSpacesDropDown from "components/FacilityRequestComponents/AH/Reusable/AfterHoursSpacesDropDown";
import EstimatedCostDetailsModal from "components/FacilityRequestComponents/AH/EstimatedCostDetailsModal";
import styles from "../Maintenance/maintenance.module.css";
import AHstyles from "./Modules/AfterHours.module.css";
import CustomRadioButton from "./Modules/CustomRadioButton.module.css";
import user_svg from "Assets/icons/Icons__error.svg";

import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth, getDate, format, isAfter } from "date-fns";
import { GetCalculateCost } from "action/tenantAction";
import { SaveRequest } from "action/requestAction";
import { setAmplitudeEvent } from "amplitude/amplitude";
import TraneEnsembleDateTimepicker from "../TraneEnsembleDateTimepicker";

const formatedTime = "h:mm a";
let errorMessage = null;  

// Helper to merge date and time as local time (no timezone shift)
export function mergeDateAndTime(dateVal, timeVal) {
  if (!dateVal || !timeVal) return null;
  // Accept Date objects or strings for both date and time
  let dateStr, timeStr;
  if (dateVal instanceof Date) {
    // Format as yyyy-MM-dd
    dateStr = format(dateVal, 'yyyy-MM-dd');
  } else {
    dateStr = dateVal;
  }
  if (timeVal instanceof Date) {
    // Format as HH:mm
    timeStr = format(timeVal, 'HH:mm');
  } else {
    timeStr = timeVal;
  }
  const [year, month, day] = dateStr.split('-').map(Number);
  const [hour, minute] = timeStr.split(':').map(Number);
  return new Date(year, month - 1, day, hour, minute, 0, 0);
}
class CreateAfterHoursRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayErrorMessages: false,
      navigateToAfterHoursList_state: false,
      modal: false,
      estimatedValue: "---",
      isSingleRequest: true,
      startDate: null,
      stopDate: null,
      startTime: null, // Set default time to 12 PM
      stopTime: null, // Set default time to 12 PM
      onPageLoad: true,
      selectedZoneDetails: null,
      saveAndCreateAnother: false,
      daysFallingBetweenDateRange: [],
      errorRecurringDaysNotSelected: false,
      errorDisableViewDetailsModallink: false,
      errorCurrentTimeError: false,
      errorStartTimeGreater: false,
      errorStartDateGreater: false,
      errorDateFields: false,
      errorEstimateCurrentTimeError: false,
      usedZone: false,
      default_selectedZoneDetailID: null,
      minimumAfterHours: null,
      numberOfSpacesAssigned: 0,
      spacesCount: 0,
      saveErrorMessage: null,
      savingRequestError: false,
    };

    this.selectRequestType = this.selectRequestType.bind(this);
    this.toggle = this.toggle.bind(this);
    this.navigateToAfterHoursList = this.navigateToAfterHoursList.bind(this);
    this.getSingleRequestHTML = this.getSingleRequestHTML.bind(this);
    this.getRepeatingRequestHTML = this.getRepeatingRequestHTML.bind(this);
    this.getSelectedZoneDetails = this.getSelectedZoneDetails.bind(this);
    this.getZoneLocalTime = this.getZoneLocalTime.bind(this);
    this.getCalculatedRequestDetails =
      this.getCalculatedRequestDetails.bind(this);

    this.getEstimatedCost = this.getEstimatedCost.bind(this);
    this.StartDateChange = this.StartDateChange.bind(this);
    this.StopDateChange = this.StopDateChange.bind(this);
    this.startTimeChange = this.startTimeChange.bind(this);
    this.stopTimeChange = this.stopTimeChange.bind(this);
    this.getDaysNameBetween = this.getDaysNameBetween.bind(this);
    this.selectRepeatingDay = this.selectRepeatingDay.bind(this);
    this.onSaveRequest = this.onSaveRequest.bind(this);
    this.createAnotherSaveForm = this.createAnotherSaveForm.bind(this);
    this.resetError = this.resetError.bind(this);
    this.updateStopDate_WRT_StartDate =
      this.updateStopDate_WRT_StartDate.bind(this);
    this.updateStopTime_WRT_StartTime =
      this.updateStopTime_WRT_StartTime.bind(this);
    this.validateDateBeforeSave = this.validateDateBeforeSave.bind(this);
  }


  StartDateChange(event) {
    this.resetError();
    if (event) {
      if (this.state.stopDate !== null) {
        this.updateStopDate_WRT_StartDate(event);
      }
      // Treat incoming value as a simple local date string (yyyy-MM-dd)
      const dateObj = new Date(event + "T00:00:00");
      this.setState(
        { startDate: dateObj },
        () => {
          this.getDaysNameBetween();
          this.unCheckRepeatOnCheckBoxes();
        }
      );
    } else {
      this.setState({ startDate: null, startTime: null });
    }
  }
  StopDateChange(event) {
    this.resetError();
    if (event) {
      const dateObj = new Date(event + "T00:00:00");
      this.setState(
        { stopDate: dateObj },
        () => {
          this.getDaysNameBetween();
          this.unCheckRepeatOnCheckBoxes();
        }
      );
    } else {
      this.setState({ stopDate: null, stopTime: null });
    }
  }

  startTimeChange(event) {
    this.resetError();
    // account for user clearing this field for the error messaging
    if (event) {
      if (this.state.stopTime !== null) {
        this.updateStopTime_WRT_StartTime(event);
      }
      // Store the selected time as a string (HH:mm) directly, no timezone conversion
      this.setState(
        {
          startTime: typeof event === 'string' ? event : format(event, 'HH:mm'),
          onPageLoad: false,
        },
        () => {
          this.getDaysNameBetween();
        }
      );
    } else {
      this.setState({
        startTime: null,
      });
    }
  }

  stopTimeChange(event) {
    this.resetError();
    // account for user clearing this field for the error messaging
    if (event) {
      // Store the selected time as a string (HH:mm) directly, no timezone conversion
      this.setState(
        {
          stopTime: typeof event === 'string' ? event : format(event, 'HH:mm'),
          onPageLoad: false,
        },
        () => {
          this.getDaysNameBetween();
        }
      );
    } else {
      this.setState({
        stopTime: null,
      });
    }
  }
  selectRequestType() {
    this.resetError();
    this.setState({ isSingleRequest: !this.state.isSingleRequest }, () => {
      this.getDaysNameBetween();
    });
  } //Change Request Types
  navigateToAfterHoursList() {
    this.setState({ navigateToAfterHoursList_state: true });
  } //Updating state to redirect to list page.
  createAnotherSaveForm() {
    this.setState({ saveAndCreateAnother: !this.state.saveAndCreateAnother });
  }

  updateStopDate_WRT_StartDate(event) {
    let { stopDate } = this.state;
    if (stopDate !== null) {
      const eventDate = new Date(event + "T00:00:00");
      if (isAfter(eventDate, this.state.stopDate)) this.StopDateChange(event);
    }
  }

  updateStopTime_WRT_StartTime(newStartTimeStr) {
    // Keep stop time at/after start time on same day without timezone shifts
    const { startDate, stopDate, stopTime, minimumAfterHours } = this.state;
    if (!startDate || !stopDate || !stopTime) return;
    const sameDay = format(startDate, 'yyyy-MM-dd') === format(stopDate, 'yyyy-MM-dd');
    if (!sameDay) return;
    const [sH, sM] = newStartTimeStr.split(':').map(Number);
    const [eH, eM] = typeof stopTime === 'string' ? stopTime.split(':').map(Number) : [null, null];
    if (eH === null) return;
    const startMinutes = sH * 60 + sM;
    const endMinutes = eH * 60 + eM;
    if (startMinutes >= endMinutes) {
      const increment = (minimumAfterHours || 1) * 60; // minutes
      const newEndMinutesTotal = startMinutes + increment;
      const newHour = Math.floor(newEndMinutesTotal / 60) % 24;
      const newMinute = newEndMinutesTotal % 60;
      const pad = (n) => (n < 10 ? '0' + n : n);
      const newStop = pad(newHour) + ':' + pad(newMinute);
      this.setState({ stopTime: newStop }, () => {
        // If rolls past midnight, push stopDate forward one day
        if (newEndMinutesTotal >= 24 * 60) {
          const next = new Date(stopDate);
          next.setDate(next.getDate() + 1);
          this.setState({ stopDate: next });
        }
      });
    }
  }

  toggle(toggleType) {
    //Open View Details Pop up
    if (toggleType !== "close") {
      this.getCalculatedRequestDetails("viewCalculateCostModal");
      setAmplitudeEvent("View After-Hours estimated cost", {
        "Primary Offering": "TS",
        "Current Page": "Create After-Hours page",
      });
    }
    if (this.state.estimatedValue !== "---") {
      this.setState({ modal: !this.state.modal });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.Tenant_Request_Cost !== nextProps.Tenant_Request_Cost) {
      let data = null;
      nextProps.Tenant_Request_Cost.hasOwnProperty("data")
        ? (data =
            nextProps.Tenant_Request_Cost.data.cost.currency +
            nextProps.Tenant_Request_Cost.data.cost.displayTotalAmount)
        : (data = "---");
      this.setState({ estimatedValue: data });
    }
  }

  componentDidMount() {
    localStorage.setItem("zoneSelectedfromList", false);
  }

  // Spaces/Zones functions

  getSelectedZoneDetails(selectedZoneDetail, spacesCount) {
    // On Zone/ Space dropdown change, below function would update from and to date Time to their zone time zone and To time would be dynamically assigned valued based on the min Bill Amount.
    // GetLocalTime

    // GetLocalTimeWithMinimumBillAmount
    let minBillAmount = null;
    minBillAmount =
      selectedZoneDetail !== undefined ? selectedZoneDetail.minmumAfterHour : 0;
    if (spacesCount !== undefined) {
      this.setState({ numberOfSpacesAssigned: spacesCount });
    }

    this.setState(
      {
        // defaultDate: this.GetLocalTime(),
        minimumAfterHours: minBillAmount,
        selectedZoneDetails: selectedZoneDetail,
        spacesCount: spacesCount,
      },
      () => {
        this.getEstimatedCost("estimatedView");
      }
    );
  }


  getZoneLocalTime() {
    let { selectedZoneDetails } = this.state;
    var localTime = new Date();
    var utc = localTime.getTime() + localTime.getTimezoneOffset() * 60000;
    let zoneOffset = null;
    zoneOffset =
      selectedZoneDetails !== undefined
        ? selectedZoneDetails.timeZoneOffset
        : 0;
    let localZoneTime = new Date(utc + 3600000 * zoneOffset);
    return localZoneTime;
  }

  //Repeating Request functions

  getDaysNameBetween() {
    let { isSingleRequest, startDate, stopDate } = this.state;
    //Following Function shall check the days falling between selected from and To date
    if (!isSingleRequest) {
      //Checking only for repeating request
      var from = new Date(startDate);
      var to = new Date(stopDate);
      let allDaysFallingBetweenDateRange = [];
      let daysFallingBetweenDateRange = null;

      var d = from;
      while (d <= to) {
        allDaysFallingBetweenDateRange.push(d.getDay());
        d = new Date(d.getTime() + 24 * 60 * 60 * 1000);
      }
      daysFallingBetweenDateRange = allDaysFallingBetweenDateRange.filter(
        function (elem, index, self) {
          return index === self.indexOf(elem);
        }
      );
      this.setState({
        daysFallingBetweenDateRange: daysFallingBetweenDateRange,
      });
      this.getEstimatedCost("estimatedView");
    } else {
      this.getEstimatedCost("estimatedView"); //To Do
    }
  }

  selectRepeatingDay() {
    //Check Box checking calculate estimate
    //   if(this.state.errorRecurringDaysNotSelected){this.resetError(); }   To Do: make time picker dynamic
    this.resetError();
    this.getEstimatedCost("estimatedView");
  }

  unCheckRepeatOnCheckBoxes() {
    //Uncheck Check Boxes on date changes
    if (!this.state.isSingleRequest) {
      this.refs["recur_Sunday"].checked = false;
      this.refs["recur_Monday"].checked = false;
      this.refs["recur_Tuesday"].checked = false;
      this.refs["recur_Wednesday"].checked = false;
      this.refs["recur_Thursday"].checked = false;
      this.refs["recur_Friday"].checked = false;
      this.refs["recur_Saturday"].checked = false;
    }
  }

  validateDateBeforeSave() {
    // check to see if date entries are valid
    let { startDate, stopDate, startTime, stopTime } = this.state;
    const isUnset = v => v === null || v === '';
    if (
      isUnset(startDate) &&
      isUnset(stopDate) &&
      isUnset(startTime) &&
      isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date/Time and To Date/Time";

      return false;
    }
    // if start date is the only thing selected
    if (
      !isUnset(startDate) &&
      isUnset(stopDate) &&
      isUnset(startTime) &&
      isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Time and To Date/Time";

      return false;
    }

    if (
      isUnset(startDate) &&
      !isUnset(stopDate) &&
      isUnset(startTime) &&
      isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date/Time and To Time";

      return false;
    }

    // if start values arent null but everything else is
    if (
      !isUnset(startDate) &&
      isUnset(stopDate) &&
      !isUnset(startTime) &&
      isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select To Date/Time";
      return false;
    }

    // if start values arent null but everything else is
    if (
      !isUnset(startDate) &&
      isUnset(stopDate) &&
      !isUnset(startTime) &&
      !isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select To Date";
      return false;
    }
    // if start date is null but everything else isn't
    if (
      isUnset(startDate) &&
      !isUnset(stopDate) &&
      !isUnset(startTime) &&
      !isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date";
      return false;
    }
    // if start date is null and start time but everything else is selected
    if (
      isUnset(startDate) &&
      !isUnset(stopDate) &&
      isUnset(startTime) &&
      !isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Date/Time";

      return false;
    }

    // if stop time is null but everything else is selected
    if (
      !isUnset(startDate) &&
      !isUnset(stopDate) &&
      !isUnset(startTime) &&
      isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select To Time";

      return false;
    }

    // if start time is null but everything else is selected
    if (
      !isUnset(startDate) &&
      !isUnset(stopDate) &&
      isUnset(startTime) &&
      !isUnset(stopTime)
    ) {
      this.setState({
        displayErrorMessages: true,
        errorDateFields: true,
        savingRequestError: true,
      });
      errorMessage = " Select From Time";

      return false;
    }

    return true;
  }

  //Resetting Validations to False
  resetError() {
    this.setState({
      displayErrorMessages: false,
      errorRecurringDaysNotSelected: false,
      errorDisableViewDetailsModallink: false,
      errorCurrentTimeError: false,
      errorStartTimeGreater: false,
      errorStartDateGreater: false,
      errorDateFields: false,
      errorEstimateCurrentTimeError: false,
      saveErrorMessage: null,
      savingRequestError: false,
    });
  }

  ValidateDate = (fromDate, currentZoneLocalTime, endate) => {
    // FromDate should be greater or equal to currentZoneLocalTime
    return fromDate >= currentZoneLocalTime ? true : false;
  };

  render() {
    let {
      displayErrorMessages,
      errorRecurringDaysNotSelected,
      errorCurrentTimeError,
      errorStartTimeGreater,
      errorStartDateGreater,
      savingRequestError,
    } = this.state;
    let dateSectionHTML = null;
    let default_selectedZoneDetailID = null;

    if (this.state.navigateToAfterHoursList_state) {
      return (
        <Redirect
          to={{
            pathname: "/FacilityManagement/AfterHours",
            state: {
              zoneSelectedfromDropdown: this.state.selectedZoneDetails.zoneId,
            },
          }}
        />
      );
    }
    dateSectionHTML = this.state.isSingleRequest
      ? this.getSingleRequestHTML()
      : this.getRepeatingRequestHTML();

    if (displayErrorMessages && !savingRequestError) {
      if (errorRecurringDaysNotSelected) {
        errorMessage = " Please select days in repeat on.";
      } //recurring days error Message
      else if (errorCurrentTimeError) {
        errorMessage = " Select starting time greater than zone time ";
      } //Current Time error Message
      else if (errorStartDateGreater) {
        errorMessage = " Start Date cannot be greater than end Date";
      } // Start Date cannot be greater than end Date
      else if (errorStartTimeGreater) {
        errorMessage = " Start time cannot be greater than end time.";
      } // Start Time cannot be greater than end Time
    }

    if (this.props.location.state !== undefined) {
      default_selectedZoneDetailID =
        this.props.location.state.zoneSelectedfromDropdown.zoneId;
    }

    return (
      <div>
        <div className={styles.titleSection}>
          <SubTitle text={"After-Hours"} />
        </div>

        <div className={styles.whiteContainer}>
          {/* Form Section */}
          <h3 className={styles.subTitle}>New After-Hours Request</h3>
          <div className={AHstyles.fieldrow}>
            {" "}
            <AfterHoursSpacesDropDown
              onSelectedZoneDetails={this.getSelectedZoneDetails}
              defaultZoneSlection={
                localStorage.getItem("zoneSelectedfromList") === "true"
                  ? this.state.selectedZoneDetails !== null
                    ? this.state.selectedZoneDetails.zoneId
                    : null
                  : default_selectedZoneDetailID
              }
            />{" "}
          </div>

          <div className={AHstyles.fieldrow}>
            <p className={styles.documentsformLabel}>Request Type</p>
            <div className={AHstyles.radioButtonRow}>
              <label className={CustomRadioButton.customRadioBtn}>
                Single{" "}
                <input
                  id="radio_SingleRequest"
                  type="radio"
                  ref="SingleRequest"
                  name="requestType"
                  value="0"
                  defaultChecked="true"
                  onChange={this.selectRequestType}
                />
                <span className={CustomRadioButton.checkmark}></span>
              </label>
              <label className={CustomRadioButton.customRadioBtn}>
                Repeating{" "}
                <input
                  id="radio_RepeatingRequest"
                  type="radio"
                  ref="RepeatedRequest"
                  name="requestType"
                  value="1"
                  onChange={this.selectRequestType}
                />
                <span className={CustomRadioButton.checkmark}></span>
              </label>
            </div>
          </div>

          {dateSectionHTML}

          <div className={AHstyles.fieldrow}>
            <p className={styles.formLabel}>{"Comments"}</p>
            <textarea
              className={styles.textarea}
              rows="5"
              ref="Comments"
              maxLength="1000"
            ></textarea>
          </div>

          <div className={AHstyles.fieldrow}>
            <p className={AHstyles.fieldlabelvalue}>Estimated Cost</p>{" "}
            <p className={AHstyles.viewdetailsLink} onClick={this.toggle}>
              View Details
            </p>
            <p className={AHstyles.estimatedValue}>
              {this.state.estimatedValue}
            </p>
            <p
              style={{
                display: this.state.errorEstimateCurrentTimeError ? "" : "none",
              }}
              className={AHstyles.estimatedErrorMessage}
            >
              {
                "Select starting time greater than current time for estimated Cost"
              }
            </p>
          </div>

          <div className={AHstyles.requiredFieldcontainer}>
            {" "}
            <p className={styles.requiredFieldText}>* required fields.</p>{" "}
          </div>
        </div>

        {/* Submit buttons Section */}
        <div className={styles.buttonsSections}>
          <div className={styles.buttonsSectionsSubContainer}>
            <div
              className={styles.errorBoxMessage}
              style={{
                display: displayErrorMessages ? "" : "none",
                marginRight: "5px",
              }}
            >
              <img src={user_svg} alt="Trane Logo" height="25px" width="25px" />
              {errorMessage}
            </div>
            <label className={CustomRadioButton.checkboxContainer}>
              Create another
              <input
                type="checkbox"
                onClick={this.createAnotherSaveForm}
              />{" "}
              <span className={CustomRadioButton.radioCheckmark}></span>{" "}
            </label>
            <button className={styles.saveButton} onClick={this.onSaveRequest}>
              SAVE
            </button>
            <button
              className={styles.cancelButton}
              onClick={this.navigateToAfterHoursList}
            >
              CANCEL
            </button>
          </div>
        </div>

        <Modal
          isOpen={this.state.modal}
          className={AHstyles.calculateCostModal}
          contentClassName={AHstyles.calculateModalContent}
        >
          <EstimatedCostDetailsModal
            onCloseModal={this.toggle}
            costDetails={this.props.Tenant_Request_Cost}
          />
        </Modal>
      </div>
    );
  }

  getSingleRequestHTML() {
    let singleRequesthtm = (
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <TraneEnsembleDateTimepicker
            edit={false}
            dateValue={this.state.startDate}
            timeValue={this.state.startTime}
            label="From Date/Time"
            id="fromDateTimePicker"
            date={this.StartDateChange}
            time={this.startTimeChange}
            errorDateFields={this.state.errorDateFields}
            timeFormat={formatedTime}
            name="startDateTime"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TraneEnsembleDateTimepicker
            edit={false}
            dateValue={this.state.stopDate}
            timeValue={this.state.stopTime}
            label="To Date/Time"
            id="toDateTimePicker"
            date={this.StopDateChange}
            time={this.stopTimeChange}
            errorDateFields={this.state.errorDateFields}
            timeFormat={formatedTime}
            name="endDateTime"
          />
        </Grid>
      </Grid>
    );

    return singleRequesthtm;
  }

  getRepeatingRequestHTML() {
    let { daysFallingBetweenDateRange } = this.state;
    let repeatingRequesthtm = (
      <div>
        {" "}
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <TraneEnsembleDateTimepicker
              edit={false}
              dateValue={this.state.startDate}
              timeValue={this.state.startTime}
              label="From Date/Time"
              id="fromDateTimePicker"
              date={this.StartDateChange}
              time={this.startTimeChange}
              errorDateFields={this.state.errorDateFields}
              timeFormat={formatedTime}
              name="startDateTime"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TraneEnsembleDateTimepicker
              edit={false}
              dateValue={this.state.stopDate}
              timeValue={this.state.stopTime}
              label="To Date/Time"
              id="toDateTimePicker"
              date={this.StopDateChange}
              time={this.stopTimeChange}
              errorDateFields={this.state.errorDateFields}
              timeFormat={formatedTime}
              name="endDateTime"
            />
          </Grid>
        </Grid>
        <div className={AHstyles.fieldrow}>
          <div
            className={
              this.state.errorRecurringDaysNotSelected
                ? AHstyles.repeatOnErrorContainer
                : null
            }
          >
            <p className={AHstyles.repeatOnLabel}>Repeat on</p>
            <div className={AHstyles.repeatOnContainer}>
              <label className={CustomRadioButton.checkboxContainer}>
                Sunday
                <input
                  type="checkbox"
                  ref="recur_Sunday"
                  disabled={!daysFallingBetweenDateRange.includes(0)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(0)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Monday
                <input
                  type="checkbox"
                  ref="recur_Monday"
                  disabled={!daysFallingBetweenDateRange.includes(1)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(1)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Tuesday
                <input
                  type="checkbox"
                  ref="recur_Tuesday"
                  disabled={!daysFallingBetweenDateRange.includes(2)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(2)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Wednesday
                <input
                  type="checkbox"
                  ref="recur_Wednesday"
                  disabled={!daysFallingBetweenDateRange.includes(3)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(3)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Thursday
                <input
                  type="checkbox"
                  ref="recur_Thursday"
                  disabled={!daysFallingBetweenDateRange.includes(4)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(4)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Friday
                <input
                  type="checkbox"
                  ref="recur_Friday"
                  disabled={!daysFallingBetweenDateRange.includes(5)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(5)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>

              <label className={CustomRadioButton.checkboxContainer}>
                Saturday
                <input
                  type="checkbox"
                  ref="recur_Saturday"
                  disabled={!daysFallingBetweenDateRange.includes(6)}
                  onClick={this.selectRepeatingDay}
                />
                <span
                  className={
                    daysFallingBetweenDateRange.includes(6)
                      ? this.state.errorRecurringDaysNotSelected
                        ? CustomRadioButton.errorRadioCheckmark
                        : CustomRadioButton.radioCheckmark
                      : CustomRadioButton.radioDisablesCheckmark
                  }
                ></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    );

    return repeatingRequesthtm;
  }

  onSaveRequest() {
    let { saveAndCreateAnother, selectedZoneDetails } = this.state;
    let requestDataToSubmit = null;
    errorMessage = null;
    requestDataToSubmit = this.getCalculatedRequestDetails("saveRequestForm");
    const checkedDate = this.validateDateBeforeSave();

    if (requestDataToSubmit !== undefined && checkedDate) {
      this.props.SaveRequest(requestDataToSubmit);
      var amplitude_CreateAH_EventProperties = {};
      amplitude_CreateAH_EventProperties["Primary Offering"] = "TS";
      amplitude_CreateAH_EventProperties["Number of Spaces assigned"] =
        this.state.numberOfSpacesAssigned;
      amplitude_CreateAH_EventProperties["Comments"] =
        requestDataToSubmit.Comment.length === 0 ? false : true;
      amplitude_CreateAH_EventProperties["Save and Create another"] =
        !saveAndCreateAnother ? false : true;
      amplitude_CreateAH_EventProperties["Request Type"] =
        requestDataToSubmit.IsRepeat === false
          ? "single request"
          : "repeating request";
      setAmplitudeEvent(
        "Create After-Hours request",
        amplitude_CreateAH_EventProperties
      );

      if (!saveAndCreateAnother) {
        //Save and redirect back to list
        this.navigateToAfterHoursList();
      } else {
        //Success Message
        this.setState(
          {
            displayErrorMessages: false,
            estimatedValue: "---",
            isSingleRequest: true,
            daysFallingBetweenDateRange: [],
            errorRecurringDaysNotSelected: false,
            errorDisableViewDetailsModallink: false,
            errorCurrentTimeError: false,
            errorStartTimeGreater: false,
            errorStartDateGreater: false,
            errorDateFields: false,
            errorEstimateCurrentTimeError: false,
          },
          () => {
            document.getElementById("radio_SingleRequest").checked = true;
            document.getElementById("radio_RepeatingRequest").checked = false;
            this.refs.Comments.value = "";
          }
        );
        //Display Success Message & Reset page
        this.getSelectedZoneDetails(selectedZoneDetails);
      }
    }
  }

  getEstimatedCost(costDisplayType) {
    const { stopDate, startDate, stopTime, startTime } = this.state;
    if (stopDate && startDate && startTime && stopTime) {
      let requestDataToSubmit = null;
      requestDataToSubmit = this.getCalculatedRequestDetails("estimatedView");
      if (requestDataToSubmit !== undefined) {
        this.props.GetCalculateCost(requestDataToSubmit);
      }
    }
  }

  getCalculatedRequestDetails(submitType) {
    //submitType, can be save(), viewCalculatedCost modal, estimated view
    let {
      selectedZoneDetails,
      isSingleRequest,
      startDate,
      stopDate,
      startTime,
      stopTime,
    } = this.state;
    let tenantId = null;
    let tenantUserId = null;
    let zoneId = null;
    let startDateTime = null;
    let endDateTime = null;
    let zoneLocalTime = null;
    let recuringDays = [];

    if (selectedZoneDetails !== null) {
      tenantId = selectedZoneDetails.tenantId;
      tenantUserId = selectedZoneDetails.tenantUserId;
      zoneId = selectedZoneDetails.zoneId;
      // Use mergeDateAndTime to combine date and time as local time
      const startDateObj = mergeDateAndTime(startDate, startTime);
      const stopDateObj = mergeDateAndTime(stopDate, stopTime);
      startDateTime = startDateObj ? format(startDateObj, 'yyyy/MM/dd HH:mm:00') : null;
      let RecurEndTime = stopDateObj ? format(stopDateObj, 'yyyy/MM/dd HH:mm:00') : null;
      zoneLocalTime = this.getZoneLocalTime();

      // Early validation: start must be strictly before stop when both provided (except initial onPageLoad allowance)
      if (
        startDateObj &&
        stopDateObj &&
        !this.state.onPageLoad &&
        startDateObj >= stopDateObj
      ) {
        const sameCalendarDay = format(startDateObj, 'yyyy-MM-dd') === format(stopDateObj, 'yyyy-MM-dd');
        if (sameCalendarDay) {
          this.setState({
            displayErrorMessages: true,
            errorDateFields: true,
            errorStartTimeGreater: true,
            errorStartDateGreater: false,
            estimatedValue: '---'
          });
        } else {
          this.setState({
            displayErrorMessages: true,
            errorDateFields: true,
            errorStartDateGreater: true,
            errorStartTimeGreater: false,
            estimatedValue: '---'
          });
        }
        return; // invalid range
      }

      if ((startDateObj && stopDateObj && (startDateObj < stopDateObj)) || this.state.onPageLoad) {
        if (isSingleRequest) {
          endDateTime = stopDateObj ? format(stopDateObj, 'yyyy/MM/dd HH:mm:00') : null;
        } else {
          //False is Repeating request
          // get recuring days
          let twoDigitMonth =
            (getMonth(stopDate) + 1).toString().length > 1
              ? getMonth(stopDate) + 1
              : "0" + (getMonth(stopDate) + 1).toString();
          let twoDigitDay =
            getDate(stopDate).toString().length > 1
              ? getDate(stopDate)
              : "0" + getDate(stopDate).toString();
          endDateTime = `${twoDigitDay}/${twoDigitMonth}/${getYear(stopDate)}`;

          if (this.refs.recur_Sunday.checked) {
            recuringDays.push("0");
          }
          if (this.refs.recur_Monday.checked) {
            recuringDays.push("1");
          }
          if (this.refs.recur_Tuesday.checked) {
            recuringDays.push("2");
          }
          if (this.refs.recur_Wednesday.checked) {
            recuringDays.push("3");
          }
          if (this.refs.recur_Thursday.checked) {
            recuringDays.push("4");
          }
          if (this.refs.recur_Friday.checked) {
            recuringDays.push("5");
          }
          if (this.refs.recur_Saturday.checked) {
            recuringDays.push("6");
          }
          // fetch recurring days
        }

        zoneLocalTime = this.getZoneLocalTime();

  if (this.ValidateDate(startDateObj, zoneLocalTime, stopDateObj)) {
          let Request = null;
          if (this.state.isSingleRequest) {
            Request = {
              StartDateTime: startDateTime,
              EndDateTime: endDateTime,
              IsRepeat: !this.state.isSingleRequest,
              TenantId: tenantId,
              ZoneId: zoneId,
              Comment: this.refs.Comments.value,
              TenantUserId: tenantUserId,
            };
            return Request;
          } else {
            if (recuringDays.length <= 0) {
              if (submitType === "estimatedView") {
                this.setState({ estimatedValue: "---" });
              } else if (submitType === "saveRequestForm") {
                this.setState({
                  displayErrorMessages: true,
                  errorDateFields: true,
                  errorRecurringDaysNotSelected: true,
                });
                //Error recurring days not Selected
              } else if (submitType === "viewCalculateCostModal") {
                this.setState({ errorDisableViewDetailsModallink: true });
                //Do Not open Modal
              }
            } else {
              Request = {
                StartDateTime: startDateTime,
                EndDateTime: endDateTime,
                IsRepeat: !this.state.isSingleRequest,
                TenantId: tenantId,
                ZoneId: zoneId,
                Comment: this.refs.Comments.value,
                TenantUserId: tenantUserId,
                EndDateTime: RecurEndTime,
                RecurDays: recuringDays,
                RecurTime: endDateTime,
              };
              return Request;
            }
          }
        } else { // start is before stop but before current zone time
          if (submitType === 'saveRequestForm') {
            this.setState({
              displayErrorMessages: true,
              errorDateFields: true,
              errorCurrentTimeError: true,
              estimatedValue: '---'
            });
          } else if (submitType === 'estimatedView') {
            this.setState({
              errorEstimateCurrentTimeError: true,
              estimatedValue: '---',
              errorDateFields: true
            });
          }
        }
      }
    } else {
      this.setState({ estimatedValue: "---" });
    }
  }

}

const mapStateToProps = (state) => {
  return {
    getLabels:
      state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
    getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields,
    Tenant_Request_Cost: state.tenantsRootReducer.Cost,
    Request_Selected_Response: state.RequestRootReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetCalculateCost: (data) => dispatch(GetCalculateCost(data)),
    SaveRequest: (data) => dispatch(SaveRequest(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAfterHoursRequest);
